'use strict';

// TODO: make this properly extendable, allow custom overrides per page

function EasterEgg() {
  var _this2 = this;

  this.id = null;
  this.node = null;

  this.el = {};

  this.init = function () {};

  this.initAllReady = function () {};

  this.easterEggInit = function () {
    var _this = this;

    this.el.portal = document.querySelector('.portal');
    var pattern = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
    var current = 0;

    var keyHandler = function keyHandler(e) {
      // If the key isn't in the pattern, or isn't the current key in the pattern, reset
      if (!pattern.includes(e.key) || e.key !== pattern[current]) {
        current = 0;
        return;
      }

      // Update how much of the pattern is complete
      current++;

      // If complete, reset and run easter egg
      if (pattern.length === current) {
        current = 0;
        var holidays = moment('2020-01-01');
        if (moment().isSameOrBefore(holidays)) {
          _this._snowFlake();
        } else {
          _this._barrelRoll();
        }
      }
    };

    document.addEventListener('keydown', keyHandler, false);
  };

  this._barrelRoll = function () {
    _this2.el.portal.classList.add('barrel-roll');
    setTimeout(function () {
      _this2.el.portal.classList.remove('barrel-roll');
    }, 1000);
  };

  this._snowFlake = function () {
    $('body').prepend('<div class="snowfall"></div>');
    for (var i = 0; i < 150; i++) {
      $('.snowfall').prepend('<div class="snowflake"></div>');
    }
    setTimeout(function () {
      $('body .snowfall').remove();
    }, 30000);
  };
}